module.exports = __webpack_public_path__ + "img/El-Salvador.3f329dd8.png";